if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.reserveMediaBox(activeMedia);
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      /*
       * Arctic: hold a correctly proportioned box while the image loads.
       * Modal images are `loading="lazy"` inside a hidden dialog, so they
       * only start fetching when the dialog opens; until then the <img> has
       * no intrinsic size and, as a flex item in the boxed lightbox, it
       * collapses to a couple of pixels — the card renders as a blob with
       * just the close button in it. The width/height attributes give the
       * ratio up front, so publish it as a custom property and let
       * `.product-media-modal__content--loading` size the card from it
       * (see the lightbox block in section-main-product.css). The class
       * comes off on load, after which the image sizes the card itself.
       */
      reserveMediaBox(activeMedia) {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;

        const clear = () => {
          content.classList.remove('product-media-modal__content--loading');
          content.style.removeProperty('--modal-media-ratio');
        };

        const width = Number(activeMedia.getAttribute('width'));
        const height = Number(activeMedia.getAttribute('height'));

        if (activeMedia.nodeName !== 'IMG' || activeMedia.complete || !width || !height) {
          clear();
          return;
        }

        content.style.setProperty('--modal-media-ratio', width / height);
        content.classList.add('product-media-modal__content--loading');
        activeMedia.addEventListener('load', clear, { once: true });
        activeMedia.addEventListener('error', clear, { once: true });
      }
    }
  );
}
